<template>
  <sky-suffix v-bind="$attrs"
              @search-click="search">
    <el-select :value="value"
               @change="change"
               v-bind="$attrs"
               filterable
               remote
               reserve-keyword
               placeholder="请输入关键词"
               :remote-method="remoteMethod"
               :loading="loading"
               @search-click="search">
      <el-option v-for="item in list"
                 :key="item[props.value]"
                 :label="item[props.label]"
                 :value="item[props.value]">
      </el-option>
    </el-select>
    <slot name="toolTips"
          slot="toolTips"></slot>
  </sky-suffix>
</template>
<script>
import SkySuffix from "../formComponents/SkySuffix.vue";
import formStore from '@/mixins/formStore.js'
export default {
  name: "sky-select",
  componentName: "sky-select",
  mixins: [formStore],
  components: {
    SkySuffix
  },
  props: {
    value: {
      default: null
    },
    options: {
      default: function () {
        return [];
      }
    },
    props: {
      default () {
        return {
          label: "label",
          value: "value"
        };
      }
    },
    queryFunc: {
      type: Function
    },
    setLabelFun: {
      type: Function
    },
    defaultValue: {
      default: ""
    }
  },
  created () { },
  data () {
    return {
      selected: this.value,
      list: this.options,
      loading: false
    };
  },
  watch: {
    defaultValue: {
      handler (val) {
        this.remoteMethod(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    search (e) {
      this.$emit("search-click", e);
    },
    change (val) {
      this.selfData = val;
      !this.delay && this.setVal();
      this.$emit("change", val);
      if (this.setLabelFun) this.setLabel(val)
    },
    setLabel (val) {
      let obj = this.list.find(item =>{
        return val === item[this.props.value]
      })
      this.setLabelFun(obj[this.props.label])
    },
    async remoteMethod (query) {
      if (query !== "") {
        this.loading = true;
        let result = await this.queryFunc.call(this, query)
        this.list = result.data;
        this.loading = false;
      } else {
        this.list = [];
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.el-select {
	width: 100%;
}
</style>
